import { Component, OnInit } from '@angular/core';
import { PasswordService } from '../services/password.service';
import { UserService } from '../services/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Globals } from 'src/app/shared/services/globals';
import { TranslateService } from '@ngx-translate/core';
import { NgForm } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { ResponseStatusEnum } from 'src/app/shared/models/system/response-status.enum';
import { forgetPasswordMail } from 'src/app/shared/models/VM/forgetPasswordMailVM';

@Component({
  selector: 'app-send-email-form',
  templateUrl: './send-email-form.component.html',
  styleUrls: ['./send-email-form.component.css']
})
export class SendEmailFormComponent implements OnInit {

  submitted: boolean;
  isRequesting: boolean;
  errors: string;
  email;
  pageUrl;
  forgetPasswordMail:forgetPasswordMail;
  constructor( public passwordService: PasswordService,private userService: UserService, private router: Router, public global: Globals,
     private currentRoute: ActivatedRoute, translate: TranslateService) {

    translate.setDefaultLang('AR');
    this.pageUrl=window.location.href.replace("/ForgetPasswordEmail","/ForgetPassword");


   }

  ngOnInit() {
    this.forgetPasswordMail=  {Email:"",PageUrl:""};
  }


  private markFormGroupTouched(formGroup: NgForm) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }


  SendEmail( value : NgForm ) {
    this.global.spinner=true;
    this.submitted = true;
    this.errors = '';

    if (value.valid) {
      this.forgetPasswordMail.Email=this.email;
      this.forgetPasswordMail.PageUrl=this.pageUrl;

      this.passwordService.sendEmail(this.forgetPasswordMail).subscribe(
      (result:any) => {
        this.global.spinner=false;
        this.global.Messages = result.messages;
        this.global.status = result.status;

        if (this.global.status == ResponseStatusEnum.OK) {
          this.router.navigateByUrl("/sendEmailConfiramation");
        }
        else {
          console.error(this.global.Messages[0].body);
        }
      }),
      (error) => {
        this.global.spinner=false;
        this.errors = 'ERR' + error;
      };
    }
    else
    {
      this.markFormGroupTouched(value);
    }

  }
}
